export default {
  customer: {
    label: "Customer",
    telephone1: "Phone 1",
    telephone2: "Phone 2",
    active: "Active",
    solded: "Solded",
    totalToPay: "Total to pay",
    totalPaid: "Total paid",
    add: {
      title: "Add a client",
      confirm: "Add"
    },
    fields: {
      nom: "Last name",
      prenom: "First name(s)",
      telephone1: "Phone 1",
      telephone2: "Phone 2"
    },
    update: {
      title: "Edit a client",
      confirm: "Edit",
      cancel: "Cancel"
    },
    nameOnly: "Last name",
    firstname: "First name(s)",
    filter: {
      title: "Filter the client list",
      isActive: "Active client?",
      isSold: "Has paid?",
      village: "Village / Neighborhood",
      selectVillage: "Select a village",
      buttons: {
        filter: "Filter",
        clear: "Clear filters",
        cancel: "Cancel"
      }
    },
    delete: {
      title: "Delete",
      body: "Are you sure you want to delete this user?",
      confirm: "Delete"
    },
    eligibleCounters: "Eligible counters",
    addressedCounters: "Addressed counters",
    name: "Full name",
    phone1: "Phone 1",
    phone2: "Phone 2",
    placeCounter: "Counter slot number",
    isSold: "Has paid?",
    isActive: "Is active?",
    actions: "Actions",

    double: {
      table: {
        name: "Full name",
        firstname: "First name",
        phone1: "Phone 1",
        phone2: "Phone 2",
        isActive: "Active?",
        isSold: "Paid?",
        isValidated: "Validated?",
        placeCounter: "Counter slot number",
        actions: "Actions",
        counters: "Counters",
        uuidONA: "ONA UUID",
        eligible: "Eligible?",
        latitude: "Latitude",
        longitude: "Longitude",
        twoWires: "2 Wires",
        fourWires: "4 Wires",
        companyWorks: "Company name",
        surveyor: "Surveyor",
        duplicateCount: "Number of occurrences",
        isSolded: "Has paid?"
      },
      buttons: {
        refresh: "Refresh",
        combine: "Merge",
        modify: "Edit client",
        details: "View client details",
        delete: "Delete client",
        validate: "Validate client",
        unvalidate: "Unvalidate client",
        counters: "Counters",
        map: "Map",
        confirmUpdate: "Edit",
        cancel: "Cancel",
        settings: "Settings",
        viewDuplicates: "View duplicates",
        view: "View"
      },
      modals: {
        deleteTitle: "Delete",
        deleteBody: "Are you sure you want to delete this user?",
        deleteConfirm: "Delete",
        updateTitle: "Edit a client",
        updateConfirm: "Edit",
        updateCancel: "Cancel",
        settingsTitle: "Duplicate settings",
      },
      settings: {
        settingsTitle: "Duplicate settings",
        compareNameFirstname: "Compare last name and first name",
        comparePhone: "Compare phone number",
        compareInvestigator: "Compare surveyor",
        compareGPS: "Compare GPS position",
        gpsPrecision: "GPS precision:"
      }
    }
  },
  placeCounters: {
    popupTitle: "Add a counter slot",
    steps: {
      step1: "Residence area",
      step2: "GPS position",
      step3: "Number of counters",
      step4: "Client information",
      step5: "Surveyor and references"
    },
    labels: {
      villageQuartier: "Village/Neighborhood",
      latitude: "Latitude",
      longitude: "Longitude",
      compteur2Fils: "2-wire counters",
      compteur4Fils: "4-wire counters",
      systemeElectriqueDispo: "Available electrical system?",
      equipementLourdDispo: "Available heavy equipment?",
      typeAbonne: "Subscriber type",
      raisonSociale: "Company name",
      nom: "Last name",
      prenom: "First name",
      telephone: "Phone",
      typeAgr: "AGR type",
      typeInfra: "Infrastructure type",
      typeInfraDetail: "Infrastructure details",
      nomEnqueteur: "Surveyor name",
      commentaireEnqueteur: "Surveyor comment",
      reference: "Reference",
      dateEnquete: "Survey date"
    },
    placeholders: {
      villageQuartier: "Select a village/neighborhood",
      typeAbonne: "Select subscriber type",
      typeAgr: "Select a type",
      typeInfra: "Select a type"
    },
    switches: {
      yes: "Yes",
      no: "No"
    },
    errors: {
      required: "This field is required",
      invalidNumber: "Invalid numeric value"
    },
    buttons: {
      add: "Add",
      cancel: "Cancel",
      next: "Next",
      previous: "Previous"
    }
  },
  counter: {
    list: "Counters",
    addTitle: "Add a counter",
    editTitle: "Edit counter",
    counterNumber: "Counter N°{num}",
    counterType: "Counter type",
    selectType: "Select counter type",
    length2x16: "2 x 16 mm²",
    length4x16: "4 x 16 mm²",
    subscriptionDate: "Subscription date",
    connectionDate: "Connection date",
    activationDate: "Activation date",
    subscriptionNumber: "Subscription policy number",
    breakerType: "Breaker type",
    selectBreakerType: "Select breaker type",
    breakerSetting: "Breaker setting",
    selectBreakerSetting: "Select breaker setting",
    delete: {
      title: "Delete",
      body: "Are you sure you want to delete this counter?",
      confirm: "Delete",
      action: "Delete counter"
    },
    none: "No counters to display"
  },
  map: {
    title: "Map"
  }
};
